<nav class="navbar fixed-top" *ngIf="tipoAcceso == 2">
    <div class="ml-2 ml-md-4 d-flex align-items-center navbar-left">
        <div>
            <img src="../../../../assets/img/imgMenu/circle-reda-logo.png" class="logo-reda-white">
        </div>
        <div class="ml-2 ml-md-3 d-none d-sm-block">
            <span class="font-weight-bold text-white">Configuraciones Reda</span>
        </div>
    </div>

    <!--..............LOGO CENTRAL .................-->
    <a class="navbar-logo" href="/">
        <span class="logo d-none d-xs-block"></span>
        <span class="logo-mobile d-block d-xs-none"></span>
    </a>

    <div class="navbar-right mr-2 mr-md-3">
        <div class="header-icons d-inline-block align-middle">
        </div>

        <div class="d-inline-block align-middle mr-2">
            <button class="btn btn-empty p-0" type="button" (click)="verConfiguracionesGenerales()" title="Configuraciones Generales">
                <i class="fa fa-cog text-white" style="font-size: 1.2rem;"></i>
            </button>
        </div>

        <div class="user d-inline-block" dropdown>
            <button class="btn btn-empty p-0 ml-1 ml-md-2" type="button" dropdownToggle>
                <div class="d-flex flex-row">
                    <div class="pl-1 pr-1">
                        <p class="font-weight-bold text-white mb-0 d-none d-md-block" style="text-align: start;">{{ this.usuarioLogeado?.nombre }}</p>
                        <p class="mb-0 mt-0 text-white d-none d-sm-block">{{ this.usuarioLogeado?.login }}</p>
                        <p class="font-weight-bold text-white mb-0 d-block d-md-none" style="font-size: 0.9rem;">{{ this.usuarioLogeado?.nombre }}</p>
                    </div>
                </div>
            </button>
        </div>

    </div>
</nav>

<nav class="navbar fixed-top" *ngIf="tipoAcceso == 1">
    <div class="ml-2 ml-md-4 d-flex align-items-center navbar-left">
        <div>
            <img src="../../../../assets/img/imgMenu/circle-reda-logo.png" class="logo-reda-white">
        </div>
        <div class="ml-2 ml-md-3 d-none d-sm-block">
            <span class="font-weight-bold text-white">Configuraciones Reda</span>
        </div>
    </div>

    <a class="navbar-logo" href="/">
        <span class="logo d-none d-xs-block"></span>
        <span class="logo-mobile d-block d-xs-none"></span>
    </a>

    <div class="navbar-right">
        <div class="user d-inline-block" dropdown>
            <button (click)="cerrar()" class="btn btn-empty p-0 mr-2" type="button" dropdownToggle>
                <span class="name text-white font-weight-bold mb-0">
                    <i class="fa fa-reply" aria-hidden="true"></i>
                    <span class="d-none d-sm-inline ml-1">Regresar al CRM</span>
                    <span class="d-inline d-sm-none ml-1">CRM</span>
                </span>
            </button>
        </div>
    </div>
</nav>

<!-- <ng-template #templateNotificaciones>
    <div class="modal-header color-reda-background">
        <h4 class="modal-title pull-left font-weight-bold" style=" color:white;">Notificaciones</h4>
        <button type="button" class="close pull-right white" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 15px;">
        <div *ngIf="loadingNotificaciones" class="text-center animated fadeIn fast" style="margin-top: 200px;">
            <i style="color: black; width: 40px;font-size: 30px;" class="fa-solid fa-spinner fa-spin fa-2x mb-1"></i>
            <p class="text-center" style="font-weight: bold;">Cargando notificaciónes</p>
        </div>

        <ng-container *ngIf="!loadingNotificaciones">
            <div *ngIf="this.notificaciones.length==0" class="text-center animated fadeIn fast" style="margin-top: 200px;">
                <img style="width: 130px; height: 130px;" src="../../../../assets/img/93134-not-found.gif" class="card-img-top text-center" />
                <p class="text-center" style="font-weight: bold;">No se encontraron notificaciones</p>
            </div>
            <perfect-scrollbar *ngIf="this.notificaciones.length>0">
                <div *ngFor="let not of  notificaciones;" (click)="marcarComoLeidoNotificacion(not.key,not.valor.Tipo,not.valor)" class="d-flex flex-row mb-3 pb-3 border-bottom justify-content-between align-items-center card-hovers" style="cursor:pointer;">
                    <div class="circulo">
                        <img src="{{iconosNotificaciones[not.valor.Tipo]}}" style="background-color: #dddddd7a; height: 27px;" class="img-thumbnail list-thumbnail xsmall border-0">
                    </div>
                    <div class="pl-3 flex-fill">
                        <p class="font-weight-bold mb-0 text-key-{{not.key}}">{{not.valor.Titulo}}</p>
                        <p class="text-muted mb-0 text-small">{{not.valor.TextoMensaje}}</p>
                        <p class="font-weight-bold text-black mb-0 text-small" style="float:right; font-size: 11px !important;">{{not.valor.FechaHoraUM | date:"medium"}}</p>
                    </div>
                </div>
            </perfect-scrollbar>
        </ng-container>
    </div>
</ng-template> -->

<ng-template #soporteReda>
    <div class="modal-header color-reda-background">
        <h4 class="modal-title pull-left font-weight-bold" style=" color:white;">Soporte reda</h4>
        <button type="button" class="close pull-right white" aria-label="Close" (click)="modalRefSoporte.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
    <div class="modal-body">
        <p class="font-weight-bold">¿Como te podemos ayudar?</p>
        <div class="text-center">
            <div class="text-center animated fadeIn fast">
                <img style="width: 100px;
        height: 100px;" src="../../../../assets/img/whatsappConexion.png" class="card-img-top text-center mb-1" />
                <p class="">Necesitas ayuda, contáctanos a través de whatsapp </p>
            </div>
            <p class="font-weight-bold">Soporte reda</p>
        </div>
    </div>
</ng-template>
<simple-notifications></simple-notifications>